import { useCallback, useRef, useState } from 'react';

// Kleiner Toast unten in der Mitte (Styles: .tipp-toast in styles/ui.css).
// Nutzung: const { zeigeToast, ToastElement } = useToast(); … {ToastElement}
export default function useToast(dauerMs = 2800) {
  const [toast, setToast] = useState(null);
  const timer = useRef(null);

  const zeigeToast = useCallback((text, fehler = false) => {
    setToast({ text, fehler });
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setToast(null), dauerMs);
  }, [dauerMs]);

  const ToastElement = toast ? (
    <div className={`tipp-toast${toast.fehler ? ' tipp-toast--fehler' : ''}`} role="status">{toast.text}</div>
  ) : null;

  return { zeigeToast, ToastElement };
}
